export default __webpack_public_path__ + "static/media/check-mark.dfdd4392.svg";